export const products = [
  {
    id: '1',
    title: 'Sulcador Ajustável Kawashima',
    description: 'Sulcador Ajustável Kawashima P/ Motocultivador MCG 780 MCD 580',
    price: 357.23,
    imageUrl: '../assets/products/sulcador.png',
    inventory: 330,
    imageRef: '',
    imageFileName: '',
    category: '',
  },
  {
    id: '2',
    title: 'Pulverizador Quadriciclo',
    description: 'Pulverizador Quadriciclo Barra E Lança 15m Plq0150 Moldemaq',
    price: 8829.29,
    imageUrl: '../assets/products/pulverizador.png',
    inventory: 330,
    imageRef: '',
    imageFileName: '',
    category: '',
  },
  {
    id: '3',
    title: 'Carreta Agrícola',
    description: 'Carreta Agrícola P/ Trator Transporte De Grama Trapp 2930071 Até 225Kg',
    price: 1574.19,
    imageUrl: '../assets/products/carreta.png',
    inventory: 330,
    imageRef: '',
    imageFileName: '',
    category: '',
  },
  {
    id: '4',
    title: 'Sela Artesanal para Tambor',
    description: 'Sela Artesanal para Tambor Master Selas 1007MS',
    price: 3357.23,
    imageUrl: '../assets/products/sela.png',
    inventory: 3,
    imageRef: '',
    imageFileName: '',
    category: '',
  },
  {
    id: '5',
    title: 'Pulverizador Quadriciclo',
    description: 'Pulverizador Quadriciclo Barra E Lança 15m Plq0150 Moldemaq',
    price: 8829.29,
    imageUrl: '../assets/products/pulverizador.png',
    inventory: 330,
    imageRef: '',
    imageFileName: '',
    category: '',
  },
  {
    id: '6',
    title: 'Carreta Agrícola',
    description: 'Carreta Agrícola P/ Trator Transporte De Grama Trapp 2930071 Até 225Kg',
    price: 1574.19,
    imageUrl: '../assets/products/carreta.png',
    inventory: 330,
    imageRef: '',
    imageFileName: '',
    category: '',
  },
  {
    id: '7',
    title: 'Sulcador Ajustável Kawashima',
    description: 'Sulcador Ajustável Kawashima P/ Motocultivador MCG 780 MCD 580',
    price: 357.23,
    imageUrl: '../assets/products/sulcador.png',
    inventory: 330,
    imageRef: '',
    imageFileName: '',
    category: '',
  },
  {
    id: '8',
    title: 'Sela Artesanal para Tambor',
    description: 'Sela Artesanal para Tambor Master Selas 1007MS',
    price: 3357.23,
    imageUrl: '../assets/products/sela.png',
    inventory: 3,
    imageRef: '',
    imageFileName: '',
    category: '',
  },
]
